import { CheckInStatusEnum } from "app/shared/enums/check-in-status-type.enum";

export class StorePosRequestModel {
  public channels: number[];
  public checkInMessage: string;
  public checkInStatus: CheckInStatusEnum;
  public storeId: number;
  public tierId: number;

  constructor(init?: StorePosRequestModel) {
    Object.assign(this, init);
  }
}